import { Button, CssBaseline, CircularProgress } from '@mui/material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DateRangeIcon from '@mui/icons-material/DateRange';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import React, { useEffect, useRef, useState } from 'react';

import { Colors } from "../../constants/Colors";
import { Fonts } from "../../constants/Fonts";
import { InsertCreditCard } from '../../services/Card';

const IUGU_ACCOUNT_ID = '0BD6829D5D4A62BC5A83C240E45BB168'
const FIRST_INPUT_PLACE_HOLDER = 'Número do cartão'
const SECOND_INPUT_PLACE_HOLDER = 'Titular do cartão'
const THIRD_INPUT_PLACE_HOLDER = 'Validade (mm/aaaa)'
const FOURTH_INPUT_PLACE_HOLDER = 'Código de segurança (CVV)'
const FIFTH_INPUT_PLACE_HOLDER = 'CPF/CNPJ do titular'

const ONLY_NUMBER_REGEX_PATTERN = /^[0-9\b]+$/

const TestCard = {
    CardNumber: '5162924579784236',
    HolderName: 'Guilherme Lima Cruz',
    Expiration: '11/2028',
    Verification: '504',
    Document: '44877415807'
}

const dev = false;

export default function InsertCard ( props )
{
    const USER_ID = props.history.location.pathname.replace( '/InsertCard:', '' )

    const [ CardNumber, setCardNumber ] = useState( dev ? TestCard.CardNumber : '' )
    const [ HolderName, setHolderName ] = useState( dev ? TestCard.HolderName : '' )
    const [ ValidDate, setValidDate ] = useState( dev ? TestCard.Expiration : '' )
    const [ SecurityNumber, setSecurityNumber ] = useState( dev ? TestCard.Verification : '' )
    const [ HolderDocumentNumber, setHolderDocumentNumber ] = useState( dev ? TestCard.Document : '' )

    const [ CardNumberValid, setCardNumberValid ] = useState( false )
    const [ HolderNameValid, setHolderNameValid ] = useState( false )
    const [ ValidDateValid, setValidDateValid ] = useState( false )
    const [ SecurityNumberValid, setSecurityNumberValid ] = useState( false )
    const [ HolderDocumentNumberValid, setHolderDocumentNumberValid ] = useState( false )

    const [ ShouldDisableButton, setShouldDisableButton ] = useState( true )
    const [ IsLoading, setIsLoading ] = useState( false )
    const [ Brand, setBrand ] = useState( '' )

    const form = useRef( null )

    useEffect( () => { Mount() }, [] )

    useEffect( () =>
    {
        if ( window.Iugu.utils.validateCreditCardNumber( CardNumber ) )
        {
            setCardNumberValid( true )
            setBrand( window.Iugu.utils.getBrandByCreditCardNumber( CardNumber ) )
        }
        else
        {
            setCardNumberValid( false )
            setBrand( '' )
        }

    }, [ CardNumber ] )

    useEffect( () =>
    {
        const pattern = /^[a-zA-Z\u00C0-\u017F´]{2,40}( [a-zA-Z\u00C0-\u017F´]{2,40})+$/;

        if ( pattern.test( HolderName.trim() ) )
        {
            setHolderNameValid( true )
        }
        else
        {
            setHolderNameValid( false )
        }

    }, [ HolderName ] )

    useEffect( () =>
    {
        if ( window.Iugu.utils.validateExpirationString( ValidDate ) && ValidDate.length === 7 )
            setValidDateValid( true )
        else
            setValidDateValid( false )
    }, [ ValidDate ] )

    useEffect( () =>
    {
        if ( Brand != undefined )
        {
            if ( window.Iugu.utils.validateCVV( SecurityNumber, Brand ) )
                setSecurityNumberValid( true )
            else
                setSecurityNumberValid( false )
        }
        else
            setSecurityNumberValid( false )

    }, [ SecurityNumber ] )

    useEffect( () =>
    {
        if ( HolderDocumentNumber.length > 11 )
        {
            if ( cnpj.isValid( HolderDocumentNumber ) )
                setHolderDocumentNumberValid( true )
            else
                setHolderDocumentNumberValid( false )
        }
        else
        {
            if ( cpf.isValid( HolderDocumentNumber ) )
                setHolderDocumentNumberValid( true )
            else
                setHolderDocumentNumberValid( false )
        }

    }, [ HolderDocumentNumber ] )

    useEffect( () =>
    {
        if ( CardNumberValid && HolderNameValid && ValidDateValid && SecurityNumberValid && HolderDocumentNumberValid )
            setShouldDisableButton( false )
        else
            setShouldDisableButton( true )

    }, [ CardNumberValid, HolderNameValid, ValidDateValid, SecurityNumberValid, HolderDocumentNumberValid ] )

    async function Mount ()
    {
        window.Iugu.setAccountID( IUGU_ACCOUNT_ID )
        window.Iugu.setTestMode( dev )
        window.Iugu.setup()
    }

    async function HandleSubmit ()
    {
        if ( !ShouldDisableButton )
        {
            setShouldDisableButton( true )
            setIsLoading( true )
            let HolderNameArray = HolderName.split( ' ' )

            let month = ValidDate.substring( 0, 2 )
            let year = ValidDate.substring( 3, ValidDate.length )
            let firstName = HolderNameArray[ 0 ]
            let lastName = HolderNameArray[ HolderNameArray.length - 1 ]

            let card = window.Iugu.CreditCard( CardNumber, month, year, firstName, lastName, SecurityNumber );

            if ( card.valid() )
            {
                window.Iugu.createPaymentToken( form.current, async function ( response )
                {
                    if ( response.errors )
                    {
                        window.postMessage( 'ERROR', '*', );
                        console.log( JSON.stringify( response.errors ) )
                        setShouldDisableButton( false )
                        setIsLoading( false )
                    }
                    else
                    {
                        let token = response.id;

                        const iJobResponse = await InsertCreditCard(
                            token
                            , USER_ID
                            , 'Credit Card'
                            , CardNumber.replace( / /g, '' ).substring( 12, 16 )
                            , Brand.toUpperCase()
                            , HolderDocumentNumber
                            , ValidDate
                            , HolderName
                            , SecurityNumber
                        )

                        if ( iJobResponse.Sucesso )
                        {
                            window.postMessage( 'SUCCESS', '*' );
                        }
                        else
                        {
                            window.postMessage( 'ERROR', '*', );
                        }
                        setIsLoading( false )
                        setShouldDisableButton( false )
                    }
                } )
            }

        }
    }

    return (
        <div style={ styles.ScreenContainer }>
            <CssBaseline />

            <form id="payment-form" ref={ form }>

                {/* Número do cartão */ }
                <div style={ styles.InputContainer } >
                    <div style={ styles.InputContentContainer }>
                        <div style={ styles.InputIconContainer }>
                            <CreditCardIcon style={ styles.InputIcon } />
                        </div>

                        <input
                            type={ 'tel' }
                            maxLength={ 16 }
                            data-iugu="number"
                            style={ styles.Input }
                            placeholder={ FIRST_INPUT_PLACE_HOLDER }
                            value={ CardNumber }

                            onChange={ e =>
                            {
                                const { value } = e.target

                                if ( ONLY_NUMBER_REGEX_PATTERN.test( value.replace( / /g, '' ) ) || value.length === 0 )
                                {
                                    if ( value.length === 16 && !value.includes( " " ) )
                                    {
                                        setCardNumber( `${ value.substring( 0, 4 ) } ${ value.substring( 4, 8 ) } ${ value.substring( 8, 12 ) } ${ value.substring( 12, 16 ) }` )
                                    }
                                    else if ( value.length < 20 && value.includes( " " ) )
                                        setCardNumber( value.replace( / /g, '' ) )
                                    else
                                        setCardNumber( value )
                                }
                            } }
                        />

                        <div style={ styles.InputIconContainer }>
                            { CardNumberValid && <CheckCircleOutlineIcon style={ styles.InputCheckIcon } /> }
                        </div>

                    </div>
                </div>

                {/* Titular do cartão */ }
                <div style={ styles.InputContainer } >
                    <div style={ styles.InputContentContainer }>
                        <div style={ styles.InputIconContainer }>
                            <AssignmentIndIcon style={ styles.InputIcon } />
                        </div>

                        <input
                            type={ 'text' }
                            data-iugu="full_name"
                            value={ HolderName }
                            style={ styles.Input }
                            placeholder={ SECOND_INPUT_PLACE_HOLDER }
                            onChange={ e => { setHolderName( e.target.value ) } }
                        />

                        <div style={ styles.InputIconContainer }>
                            { HolderNameValid && <CheckCircleOutlineIcon style={ styles.InputCheckIcon } /> }
                        </div>

                    </div>
                </div>

                {/* Validade do cartão */ }
                <div style={ styles.InputContainer } >
                    <div style={ styles.InputContentContainer }>
                        <div style={ styles.InputIconContainer }>
                            <DateRangeIcon style={ styles.InputIcon } />
                        </div>

                        <input
                            type={ 'text' }
                            data-iugu="expiration"
                            maxLength={ 7 }
                            value={ ValidDate }
                            style={ styles.Input }
                            placeholder={ THIRD_INPUT_PLACE_HOLDER }
                            onChange={ e =>
                            {
                                const { value } = e.target

                                if ( ONLY_NUMBER_REGEX_PATTERN.test( value.replace( '/', '' ) ) || value.length === 0 )
                                {
                                    if ( value.length === 6 && !value.includes( '/' ) )
                                        setValidDate( value.substring( 0, 2 ) + '/' + value.substring( 2, value.length ) )
                                    else
                                        setValidDate( value )
                                }
                            } }
                        />

                        <div style={ styles.InputIconContainer }>
                            { ValidDateValid && <CheckCircleOutlineIcon style={ styles.InputCheckIcon } /> }
                        </div>

                    </div>
                </div>

                {/* Código de segurança do cartão */ }
                <div style={ styles.InputContainer } >
                    <div style={ styles.InputContentContainer }>
                        <div style={ styles.InputIconContainer }>
                            <ConfirmationNumberIcon style={ styles.InputIcon } />
                        </div>

                        <input
                            type={ 'tel' }
                            data-iugu="verification_value"
                            maxLength={ 4 }
                            style={ styles.Input }
                            placeholder={ FOURTH_INPUT_PLACE_HOLDER }
                            value={ SecurityNumber }
                            onChange={ e =>
                            {
                                if ( ONLY_NUMBER_REGEX_PATTERN.test( e.target.value ) || e.target.value.length === 0 )
                                {
                                    setSecurityNumber( e.target.value )
                                }
                            } }
                        />

                        <div style={ styles.InputIconContainer }>
                            { SecurityNumberValid && <CheckCircleOutlineIcon style={ styles.InputCheckIcon } /> }
                        </div>

                    </div>
                </div>

                {/* CPF/CNPJ do titular */ }
                <div style={ styles.InputContainer } >
                    <div style={ styles.InputContentContainer }>
                        <div style={ styles.InputIconContainer }>
                            <FingerprintIcon style={ styles.InputIcon } />
                        </div>

                        <input
                            type={ 'tel' }
                            maxLength={ 14 }
                            style={ styles.Input }
                            placeholder={ FIFTH_INPUT_PLACE_HOLDER }
                            value={ HolderDocumentNumber }

                            onChange={ e =>
                            {
                                if ( ONLY_NUMBER_REGEX_PATTERN.test( e.target.value ) || e.target.value.length === 0 )
                                {
                                    setHolderDocumentNumber( e.target.value )
                                }
                            } }
                        />

                        <div style={ styles.InputIconContainer }>
                            { HolderDocumentNumberValid && <CheckCircleOutlineIcon style={ styles.InputCheckIcon } /> }
                        </div>

                    </div>
                </div>

                {/* Botão  */ }
                <div style={ styles.ButtonContainer } >
                    {
                        IsLoading

                            ?
                            <div style={ { alignItems: 'center', justifyContent: 'center', display: 'flex', flex: 1 } }>
                                <CircularProgress />
                            </div>
                            : <Button
                                typeof={ 'submit' }
                                onClick={ HandleSubmit }
                                style={ ShouldDisableButton ? styles.DisabledButton : styles.Button }
                                disabled={ ShouldDisableButton }>Salvar</Button>
                    }

                </div>


            </form>
        </div>
    )
}

const styles = {
    ScreenContainer:
    {
        flex: 1
        , backgroundColor: Colors.White
        , flexDirection: 'column'
        , display: 'flex'
        , minHeight: '100vh'
        , justifyContent: 'center'
    }
    , InputContainer:
    {
        paddingLeft: '5%'
        , paddingRight: '5%'
        , paddingTop: '3%'
        , display: 'flex'
        , flex: 0
    }
    , InputContentContainer:
    {
        borderRadius: 5
        , border: 'solid 1.33px #4739ea'
        , width: '100%'
        , alignItems: 'center'
        , flexDirection: 'row'
        , display: 'flex'
    }
    , InputIconContainer:
    {
        flex: 0
        , display: 'flex'
        , marginLeft: 5
        , marginRight: 5
    }
    , InputIcon:
    {
        color: '#4739ea'
        , alignSelf: 'center'
    }
    , InputCheckIcon:
    {
        color: 'green'
        , alignSelf: 'center'
    }
    , Input:
    {
        minHeight: '3rem'
        , border: 0
        , fontFamily: Fonts.Primary
        , fontWeight: '500'
        , width: '100%'
        , outlineWidth: 0

    }
    , Button:
    {
        width: '100%'
        , backgroundColor: '#4739ea'
        , paddingLeft: '5%'
        , paddingRight: '5%'
        , color: '#FFF'
        , fontFamily: Fonts.Primary
        , fontWeight: 'bold'
    }
    , DisabledButton:
    {
        width: '100%'
        , backgroundColor: 'gray'
        , paddingLeft: '5%'
        , paddingRight: '5%'
        , color: '#FFF'
        , fontFamily: Fonts.Primary
        , fontWeight: 'bold'
    }
    , ButtonContainer:
    {
        paddingLeft: '5%'
        , paddingRight: '5%'
        , paddingTop: '4%'
        , display: 'flex'
        , flex: 0
    }
}
